/* CIPRIAN STORE - Theme JS */

// Cart drawer / notification
document.addEventListener('DOMContentLoaded', function () {

  // Add to cart AJAX
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = form.querySelector('.btn-add-cart');
      const originalText = btn.textContent;
      btn.textContent = 'Agregando...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form))
      })
      .then(r => r.json())
      .then(function() {
        btn.textContent = '¡Agregado! ✓';
        btn.style.background = 'var(--color-success)';
        updateCartCount();
        setTimeout(function() {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      });
    });
  });

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(function(cart) {
        const counts = document.querySelectorAll('.cart-count');
        counts.forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      });
  }
});
